import { Divider, Grid } from "@mui/material";
import { t } from "i18next";

//import constant
import { IS_MOBILE } from "../../../constants/breakpoints";

//import images and icons
import { Filter, Sort } from "iconsax-react";

//import styles
import "./filter-sort-actions.scss";

const FilterSortAction = ({ icon: Icon, text, onClick, activeFilterCount }) => (
    <span className="filter-sort-action" onClick={IS_MOBILE ? onClick : undefined}>
        {text} {text === t("filter") && activeFilterCount && <span className="filter-sort-action__counter">{activeFilterCount}</span>}{" "}
        <Icon size={16} color="#292D32" />
    </span>
);

const FilterSortActions = ({ onFilterClick, onSortClick, selectedFilters }) => {
    const activeFilterCount = selectedFilters ? Object.keys?.(selectedFilters)?.length : "";

    return (
        <Grid container item xs={12} columnGap={1} alignItems="center">
            <FilterSortAction icon={Filter} text={t("filter")} onClick={onFilterClick} activeFilterCount={activeFilterCount} />
            <Divider flexItem orientation="vertical" />
            <FilterSortAction icon={Sort} text={t("sort")} onClick={onSortClick} activeFilterCount={activeFilterCount} />
        </Grid>
    );
};

export default FilterSortActions;
